(() => {
  const inkNames = { '#09090a': 'Black', '#4157ff': 'Blue', '#e74132': 'Red', '#167548': 'Green', '#ffffff': 'White', '#f2c600': 'Yellow' };
  function init(root) {
    const form = root.querySelector('[data-custom-order]');
    if (!form || form.dataset.initialized) return;
    const editor = window.RollMyLogoEditor, formats = window.RollMyLogoSizes.customFormats;
    if (!editor || !formats) return;
    form.dataset.initialized = 'true';
    const q = selector => form.querySelector(selector), qa = selector => [...form.querySelectorAll(selector)];
    const preview = document.body.hasAttribute('data-rml-preview');
    const shopRoot = window.Shopify?.routes?.root || '/';
    const cartURL = preview ? './cart.html' : `${shopRoot}cart`;
    const products = new Map([...root.querySelectorAll('[data-builder-product]')].map(el => {
      const { diameter, variant, priceCents, price, currency } = el.dataset;
      return [Number(diameter), { variant: variant || '', price: price || '', currency,
        priceCents: /^\d+$/.test(priceCents || '') ? Number(priceCents) : null,
        available: el.dataset.available === 'true' }];
    }));
    const state = { size: 40, ink: '#09090a', method: 'upload', file: null, adding: false, unconfirmed: false };
    const status = q('[data-order-status]'), recovery = q('[data-order-recovery]');
    recovery.href = cartURL;
    const help = root.querySelector('.rml-design-help');
    if (help) {
      const tools = document.createElement('div'); tools.className = 'rml-custom-order-tools';
      tools.append(help); root.querySelector('.rml-logo-choice').append(tools);
      help.querySelector('[data-design-help-copy]')?.addEventListener('click', async () => {
        const address = help.querySelector('[data-design-help-address]'), note = help.querySelector('[data-design-help-status]');
        try { await navigator.clipboard.writeText(address.value); note.textContent = 'Email address copied.'; }
        catch { address.focus(); address.select(); note.textContent = 'Select and copy the email address above.'; }
        note.hidden = false;
      });
    }
    root.querySelector('.rml-viewer')?.remove();
    function purchasable(product) {
      return product && Number.isSafeInteger(product.priceCents) && product.priceCents >= 0 && product.price.trim()
        && (preview || (product.available && /^[1-9]\d*$/.test(product.variant)));
    }
    function showStatus(message = '', tone = 'error') {
      status.textContent = message; status.hidden = !message;
      status.dataset.tone = tone;
      status.setAttribute('role', tone === 'notice' ? 'status' : 'alert');
    }
    function ux(name) {
      if (!preview) {
        try { window.RollMyLogoUX?.track(`RML_${name}`); }
        catch { /* Optional usability analytics must not block an order. */ }
      }
    }
    function sync() {
      const product = products.get(state.size), available = purchasable(product);
      if (!editor.orderInkAllowed(formats[state.size], state.ink)) state.ink = '#09090a';
      for (const input of qa('[data-later-size], [data-artwork-method], [data-order-file]')) input.disabled = state.adding || state.unconfirmed;
      qa('[data-later-size]').forEach(input => { input.checked = Number(input.value) === state.size; });
      qa('[data-later-ink]').forEach(input => {
        const allowed = editor.orderInkAllowed(formats[state.size], input.value);
        input.closest('.rml-order-swatch').hidden = !allowed;
        input.disabled = state.adding || state.unconfirmed || !allowed;
        input.checked = input.value === state.ink;
      });
      qa('[data-artwork-method]').forEach(input => { input.checked = input.value === state.method; });
      q('[data-order-ink-name]').textContent = inkNames[state.ink];
      q('[data-order-summary]').textContent = `${formats[state.size].label} - ${inkNames[state.ink]} ink`;
      q('[data-order-total]').textContent = product?.price || 'Unavailable';
      q('[data-order-continue-label]').textContent = state.adding ? 'Adding to cart...' : `Continue${product?.price ? ` - ${product.price}` : ''}`;
      q('[data-order-continue]').disabled = state.adding || state.unconfirmed || !available;
      q('[data-order-continue]').setAttribute('aria-busy', String(state.adding));
      q('[data-order-upload-area]').hidden = state.method !== 'upload';
      q('[data-order-file-name]').textContent = state.file?.name || '';
      q('[data-order-file-label]').textContent = state.file ? 'Change file' : 'Choose file';
      q('[data-order-file-remove]').hidden = !state.file;
      q('[data-order-file-remove]').disabled = state.adding || state.unconfirmed;
      q('[data-order-file-choose]').disabled = state.adding || state.unconfirmed;
      qa('[data-order-price]').forEach(el => { el.textContent = products.get(Number(el.dataset.orderPrice))?.price || 'Unavailable'; });
      form.setAttribute('aria-busy', String(state.adding));
    }
    // Only non-personal funnel choices are published. Standard cart/checkout/purchase
    // events remain owned by Shopify's official pixel integrations.
    function publish(name) {
      if (preview) return;
      const product = products.get(state.size);
      if (!purchasable(product)) return;
      try {
        window.Shopify?.analytics?.publish(`rml:${name}`, {
          content_type: 'product', content_name: 'Custom RollMyLogo Roller',
          variant_id: product.variant, value: product.priceCents / 100, currency: product.currency,
          print_width_mm: formats[state.size].widthMm, size: formats[state.size].label,
          artwork_method: state.method,
        })?.catch?.(() => {});
      } catch { /* Analytics must never block an order. */ }
    }
    form.addEventListener('change', event => {
      const input = event.target;
      if (state.adding || state.unconfirmed) return;
      if (input.matches('[data-later-size]')) {
        const size = Number(input.value);
        if (!formats[size] || state.size === size) return;
        state.size = size; sync(); showStatus(purchasable(products.get(size)) ? '' : 'This size is currently unavailable.'); publish('SizeSelected');
      } else if (input.matches('[data-later-ink]')) {
        if (!editor.orderInkAllowed(formats[state.size], input.value)) { sync(); return; }
        state.ink = input.value; sync();
      } else if (input.matches('[data-artwork-method]')) {
        if (!['upload', 'later'].includes(input.value) || state.method === input.value) return;
        state.method = input.value; sync(); showStatus(); publish('ArtworkMethodSelected');
        if (state.method === 'later' || state.file) ux('ArtworkReady');
      } else if (input.matches('[data-order-file]')) {
        const file = input.files?.[0]; input.value = '';
        if (!file) return;
        try { state.file = editor.validateQuickLogo(file); showStatus(); ux('FileValidated'); ux('ArtworkReady'); }
        catch (error) { state.file = null; showStatus(error.message); ux('FileRejected'); }
        sync();
      }
    });
    q('[data-order-file-choose]').addEventListener('click', () => {
      if (!state.adding && !state.unconfirmed) q('[data-order-file]').click();
    });
    q('[data-order-file-remove]').addEventListener('click', () => { if (!state.adding && !state.unconfirmed) { state.file = null; sync(); showStatus(); } });
    const readCart = async () => {
      const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to read cart.');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count)) throw new Error('Unable to read cart.');
      document.querySelectorAll('.rml-cart').forEach(link => {
        const count = link.querySelector('strong'); if (count) count.textContent = cart.item_count;
        link.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
      });
      document.dispatchEvent(new CustomEvent('rollmylogo:cart-updated', { detail: cart }));
      return cart;
    };
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (state.adding || state.unconfirmed) return;
      const product = products.get(state.size);
      if (!purchasable(product)) { showStatus('This size is currently unavailable.'); return; }
      if (state.method === 'upload' && !state.file) {
        ux('MissingLogo');
        showStatus('Don\u2019t have your logo ready? Send it after checkout.', 'notice');
        q('[data-order-file-choose]').focus({ preventScroll: true }); return;
      }
      state.adding = true; recovery.hidden = true; showStatus(); sync();
      ux('AddStarted');
      try {
        const reference = `RML-${crypto.randomUUID().replaceAll('-', '').slice(0, 12).toUpperCase()}`;
        const data = state.method === 'upload'
          ? editor.createUploadedDesign(formats[state.size], state.ink, reference, state.file)
          : editor.createDeferredDesign(formats[state.size], state.ink, reference);
        if (preview) {
          const cart = JSON.parse(localStorage.getItem('rollmylogo-demo-cart') || '[]');
          if (!Array.isArray(cart)) throw new Error('Unable to read cart.');
          cart.push({ ...data, id: data.designRef, title: 'Custom RollMyLogo Roller', quantity: 1, unitPriceCents: product.priceCents, currency: product.currency });
          localStorage.setItem('rollmylogo-demo-cart', JSON.stringify(cart));
          document.dispatchEvent(new CustomEvent('rollmylogo:cart-updated'));
        } else {
          const payload = state.method === 'upload' ? editor.uploadedPayload(data, product.variant, state.file) : editor.deferredPayload(data, product.variant);
          await editor.addOrderItem(product, data, payload, recovery, readCart, shopRoot);
        }
        ux('AddSucceeded');
        window.location.assign(cartURL);
        return;
      } catch (error) {
        state.unconfirmed = Boolean(error.cartUnconfirmed);
        ux(state.unconfirmed ? 'AddUnconfirmed' : 'AddFailed');
        showStatus(error.message || 'Unable to add your roller. Please try again.');
        state.adding = false; sync();
      }
    });
    sync();
    if (!purchasable(products.get(state.size))) showStatus('This size is currently unavailable.');
    window.lucide?.createIcons();
    const header = document.querySelector('.rml-header');
    const setAnchorOffset = () => {
      const rect = header?.getBoundingClientRect();
      root.style.scrollMarginTop = `${rect && rect.top >= 0 ? Math.ceil(rect.height) : 0}px`;
    };
    setAnchorOffset();
    if (header && window.ResizeObserver) new ResizeObserver(setAnchorOffset).observe(header);
    const alignAnchor = () => {
      if (location.hash !== '#builder') return;
      setAnchorOffset(); root.scrollIntoView({ block: 'start', behavior: 'auto' });
    };
    window.addEventListener('hashchange', alignAnchor);
    window.addEventListener('load', () => requestAnimationFrame(alignAnchor), { once: true });
    window.addEventListener('pageshow', event => { if (!event.persisted) requestAnimationFrame(alignAnchor); });
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target.closest?.('a[href="#builder"]')) requestAnimationFrame(alignAnchor);
    });
    if (location.hash === '#builder') requestAnimationFrame(alignAnchor);
    if (!preview && window.IntersectionObserver) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { publish('ViewContent'); observer.disconnect(); }
      }, { threshold: .15 });
      observer.observe(root.querySelector('.rml-logo-choice__head'));
    }
  }
  window.RollMyLogoCustomOrder = { init };
})();
